import Vue from "vue";
import App from "./App.vue";
import "./assets/sass/style.scss";

Vue.config.productionTip = false;

// new Vue({
//   render: h => h(App)
// }).$mount(".snapsupplements-catalog");

// create a constructor for your widget
var Widget = Vue.extend({
  // render: h => h(App)
  render(h) {
    return h(App, {
      props: {
        token: this.$el.attributes["snap-data-token"].value
      }
    });
  }
  // .. other options, but not `el:`
});

var nodes = document.querySelectorAll(".snapsupplements-catalog");
for (var i = 0; i < nodes.length; ++i) {
  new Widget({ el: nodes[i] });
}
